export default "__VITE_ASSET__DY8OPHQ5__"